import { render, staticRenderFns } from "./ConsultReportDetail.vue?vue&type=template&id=5704becc&"
import script from "./ConsultReportDetail.vue?vue&type=script&lang=ts&"
export * from "./ConsultReportDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ConsultReportDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports